import { render } from "./statuteEdit.vue?vue&type=template&id=07110641&scoped=true"
import script from "./statuteEdit.vue?vue&type=script&lang=js"
export * from "./statuteEdit.vue?vue&type=script&lang=js"

import "./statuteEdit.vue?vue&type=style&index=0&id=07110641&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07110641"]])

export default __exports__